
export default {
  name: 'MContent'
}
